module.exports = __webpack_public_path__ + "img/truckFrontRightOutline.8e263abe.svg";